<script>
import gsap from "gsap";

export default {
  props: {
    number: {
      type: Number,
      required: true,
    },
    numberFormat: {
      type: Boolean,
      required: false,
      default: false,
    },
    moneyFormat: {
      type: Boolean,
      required: false,
      default: false,
    },
    percentFormat: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      duration: 0,
      tweened: 0,
    };
  },
  methods: {
    change(duration) {
      gsap.to(this, { duration: duration, tweened: Number(this.number) || 0 });
    },
  },
  watch: {
    number() {
      this.change(0.3);
    },
  },
  created() {
    this.change(0);
  },
};
</script>

<template>
  <span v-if="numberFormat">
    <span v-number-format="tweened.toFixed(0)"></span>
  </span>
  <span v-else-if="moneyFormat">
    <span v-money-format="tweened.toFixed(0)"></span> €
  </span>
  <span v-else-if="percentFormat">
    <span v-percent-format="tweened.toFixed(0)"></span> %
  </span>
  <span v-else>
    <span>{{ tweened.toFixed(0) }}</span>
  </span>
</template>